import React, { useState, useEffect } from 'react';
import { Container } from './styles.js';
import Movies from './movies/index.js';
import CarouselMovie from './carousel/index.js';

function Home({ user, movies, moviesWatching, setBackgroundNav, setGetMoviesWatching }) {

  useEffect(()=> {
      window.scrollTo(0,0);
  }, [ ]);

  useEffect(() => {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', "#202020")
    document.title = 'Moov Pro';
    setBackgroundNav("#202020")
  }, []);

  return (
    <Container>
      <main>
        <CarouselMovie movies={movies} />
        <Movies user={user} movies={movies} setGetMoviesWatching={setGetMoviesWatching} moviesWatching={moviesWatching} />
      </main>
    </Container>
  );
}

export default Home;
